import React from 'react'
import SendFieldsReportButtonContainer from '../../containers/ToolsContainers/SendFieldsReportButtonContainer'
import ReportManagerButtonContainer from '../../containers/ToolsContainers/ReportManagerButtonContainer'
import ShareScreenshotButton from '../ToolsComponents/ShareScreenshotButton'

export default function DashboardLeftMenuBottom() {
  return (
    <>
      <ReportManagerButtonContainer />
      <SendFieldsReportButtonContainer />
      <ShareScreenshotButton />
    </>
  )
}
